export interface NavSite {
  id: string;
  name: string;
  url: string;
  host: string;
  letter: string;
  categoryId: string;
  subCategoryId: string;
  tags: string[];
  summary: string;
  description: string;
  audience: string;
  visits: number;
  addedAt: string;
  featured: boolean;
  image: string;
  imageSeq: string;
}

export const navSites: NavSite[] = [
  {
    id: "tencent",
    name: "腾讯网",
    url: "https://www.qq.com",
    host: "qq.com",
    letter: "腾",
    categoryId: "news",
    subCategoryId: "news-general",
    tags: ["综合门户", "新闻", "视频"],
    summary: "腾讯官方综合门户，覆盖新闻、科技、娱乐与体育资讯。",
    description:
      "腾讯网是腾讯旗下的综合资讯门户，提供新闻、财经、科技、娱乐、体育、汽车等多个频道的内容，同时整合腾讯视频、腾讯体育等子站入口。适合希望在一个页面内快速浏览全天热点的用户，新闻更新频率高，专题报道与直播栏目齐全。",
    audience: "关注时事热点、需要快速浏览综合资讯的普通网民",
    visits: 986000,
    addedAt: "2026-03-12",
    featured: true,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20digital%20newsroom%20illustration%20with%20layered%20information%20cards%20and%20soft%20blue%20gradient%20background%2C%20clean%20editorial%20tech%20visual%2C%20minimal%20geometric%20shapes%2C%20bright%20airy%20high%20key%20lighting&width=1200&height=675&seq=nav-tencent-01&orientation=landscape",
    imageSeq: "nav-tencent-01",
  },
  {
    id: "weibo",
    name: "微博",
    url: "https://weibo.com",
    host: "weibo.com",
    letter: "微",
    categoryId: "social",
    subCategoryId: "social-platform",
    tags: ["社交", "热搜", "资讯"],
    summary: "开放式社交平台，实时热搜与话题讨论的集中地。",
    description:
      "微博是国内主流的开放式社交媒体，用户可以通过图文、视频、直播等形式发布与传播内容。热搜榜与话题页让热点事件传播速度极快，适合追踪公共事件进展、关注明星与行业动态，也常被用作品牌与媒体的官方发声渠道。",
    audience: "关心社会热点、喜欢参与话题讨论的年轻网民",
    visits: 912000,
    addedAt: "2026-03-08",
    featured: true,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20social%20network%20visualization%20with%20connected%20glowing%20nodes%20floating%20on%20a%20warm%20orange%20coral%20gradient%20background%2C%20modern%20minimal%20tech%20illustration%2C%20clean%20soft%20lighting%2C%20high%20key&width=1200&height=675&seq=nav-weibo-01&orientation=landscape",
    imageSeq: "nav-weibo-01",
  },
  {
    id: "taobao",
    name: "淘宝",
    url: "https://www.taobao.com",
    host: "taobao.com",
    letter: "淘",
    categoryId: "shopping",
    subCategoryId: "shopping-mall",
    tags: ["电商", "综合商城", "比价"],
    summary: "综合网购平台，商品类目齐全，支持比价与店铺筛选。",
    description:
      "淘宝是面向大众的综合电商平台，几乎覆盖所有生活消费品类目。用户可以通过搜索、类目导航、推荐流找到商品，并借助销量、评价、价格区间等维度快速筛选。适合日常购物、囤货采买以及寻找小众特色商品的用户。",
    audience: "日常网购、追求丰富选择与价格对比的消费者",
    visits: 883000,
    addedAt: "2026-02-26",
    featured: true,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20ecommerce%20shopping%20bags%20and%20parcel%20boxes%20arranged%20in%20a%20clean%20minimal%20composition%20with%20soft%20peach%20and%20orange%20background%2C%20bright%20high%20key%20studio%20lighting%2C%20modern%20editorial%20style&width=1200&height=675&seq=nav-taobao-01&orientation=landscape",
    imageSeq: "nav-taobao-01",
  },
  {
    id: "jingdong",
    name: "京东",
    url: "https://www.jd.com",
    host: "jd.com",
    letter: "京",
    categoryId: "shopping",
    subCategoryId: "shopping-mall",
    tags: ["电商", "数码家电", "物流快"],
    summary: "自营与第三方并存，数码家电选购与快速配送首选。",
    description:
      "京东以自营商品和高效物流体系著称，3C 数码、家电、日用百货的配送体验突出。页面提供价格保护、以旧换新、分期等实用服务，商品详情页参数完善，适合对配送时效和售后要求较高的用户。",
    audience: "购买数码家电、注重物流时效与售后保障的用户",
    visits: 801000,
    addedAt: "2026-03-02",
    featured: true,
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20red%20parcel%20boxes%20and%20delivery%20cart%20abstract%20illustration%20on%20a%20pale%20cream%20background%2C%20clean%20geometric%20shapes%2C%20soft%20studio%20lighting%2C%20high%20key%20commercial%20photography%20style&width=1200&height=675&seq=nav-jd-01&orientation=landscape",
    imageSeq: "nav-jd-01",
  },
  {
    id: "bilibili",
    name: "哔哩哔哩",
    url: "https://www.bilibili.com",
    host: "bilibili.com",
    letter: "B",
    categoryId: "entertainment",
    subCategoryId: "entertainment-video",
    tags: ["视频", "二次元", "学习"],
    summary: "年轻人聚集的视频社区，动画、知识、生活内容齐全。",
    description:
      "哔哩哔哩是以中长视频为核心的内容社区，涵盖动画、游戏、知识、科技、生活、影视等分区。弹幕互动与收藏追番是平台特色，同时大量优质 UP 主提供免费公开课与技能教程，适合既想看娱乐内容又想学习的用户。",
    audience: "学生与年轻职场人，喜欢弹幕文化与知识类视频",
    visits: 764000,
    addedAt: "2026-03-16",
    featured: true,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20playful%20video%20player%20screen%20mockup%20with%20floating%20rounded%20cards%20in%20soft%20pink%20and%20aqua%20tone%2C%20minimal%20modern%20illustration%2C%20bright%20clean%20background%2C%20gentle%20glow&width=1200&height=675&seq=nav-bilibili-01&orientation=landscape",
    imageSeq: "nav-bilibili-01",
  },
  {
    id: "iqiyi",
    name: "爱奇艺",
    url: "https://www.iqiyi.com",
    host: "iqiyi.com",
    letter: "爱",
    categoryId: "entertainment",
    subCategoryId: "entertainment-video",
    tags: ["长视频", "影视剧", "综艺"],
    summary: "长视频平台，影视剧、综艺与动漫资源集中。",
    description:
      "爱奇艺提供电影、电视剧、综艺、动漫、纪录片等长视频内容，支持多端同步观看与清晰度调节。首页按热播榜、口碑榜、即将上线分类整理，方便用户快速找到想看的剧集，也提供少儿动画与体育赛事专区。",
    audience: "喜欢追剧、看综艺的家庭用户与年轻观众",
    visits: 653000,
    addedAt: "2026-02-18",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20cinema%20screen%20with%20warm%20green%20and%20mint%20ambient%20glow%2C%20floating%20film%20strip%20shapes%2C%20minimal%20geometric%20composition%2C%20soft%20high%20key%20lighting%2C%20editorial%20style&width=1200&height=675&seq=nav-iqiyi-01&orientation=landscape",
    imageSeq: "nav-iqiyi-01",
  },
  {
    id: "netease-music",
    name: "网易云音乐",
    url: "https://music.163.com",
    host: "music.163.com",
    letter: "音",
    categoryId: "entertainment",
    subCategoryId: "entertainment-music",
    tags: ["音乐", "歌单", "评论"],
    summary: "歌单推荐与乐评文化突出的在线音乐平台。",
    description:
      "网易云音乐以个性化歌单、每日推荐和高质量乐评著称，覆盖流行、独立、电子、古典等多种曲风。用户可以按心情、场景、语种筛选歌单，也经常能看到创作者与听众的长评互动，适合喜欢发现新歌的用户。",
    audience: "喜欢探索小众音乐与场景歌单的年轻听众",
    visits: 542000,
    addedAt: "2026-03-05",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20audio%20waveform%20and%20headphones%20silhouette%20on%20a%20deep%20charcoal%20gradient%20background%20with%20soft%20red%20accent%20light%2C%20minimal%20modern%20music%20visual%2C%20studio%20lighting&width=1200&height=675&seq=nav-music-01&orientation=landscape",
    imageSeq: "nav-music-01",
  },
  {
    id: "douyin",
    name: "抖音",
    url: "https://www.douyin.com",
    host: "douyin.com",
    letter: "抖",
    categoryId: "entertainment",
    subCategoryId: "entertainment-live",
    tags: ["短视频", "直播", "生活"],
    summary: "短视频与直播平台，内容更新快、覆盖生活全场景。",
    description:
      "抖音以竖屏短视频为核心，涵盖生活记录、美食、旅行、知识科普、舞蹈等大量内容分区，同时提供直播与电商入口。网页版支持搜索话题与创作者主页浏览，适合碎片化时间获取资讯与娱乐。",
    audience: "希望快速获取生活灵感与娱乐内容的泛用户",
    visits: 702000,
    addedAt: "2026-03-18",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20vertical%20short%20video%20cards%20floating%20over%20a%20soft%20dark%20navy%20background%20with%20cyan%20and%20pink%20neon%20accents%2C%20minimal%20modern%20digital%20illustration%2C%20clean%20composition&width=1200&height=675&seq=nav-douyin-01&orientation=landscape",
    imageSeq: "nav-douyin-01",
  },
  {
    id: "zhihu",
    name: "知乎",
    url: "https://www.zhihu.com",
    host: "zhihu.com",
    letter: "知",
    categoryId: "study",
    subCategoryId: "study-exam",
    tags: ["问答", "知识", "经验"],
    summary: "问答与深度内容社区，专业问题能找到长答案。",
    description:
      "知乎是以问答为核心的知识社区，用户可以提问、回答、关注话题与专栏。相比搜索结果的碎片信息，知乎的长回答常常包含完整的分析过程与实操经验，适合做决策前的调研，也适合了解行业人士的真实看法。",
    audience: "需要深度信息、做决策调研的学生与职场人士",
    visits: 598000,
    addedAt: "2026-02-22",
    featured: true,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20stack%20of%20clean%20document%20cards%20with%20question%20mark%20shapes%20on%20a%20soft%20pale%20blue%20background%2C%20minimal%20editorial%20illustration%2C%20bright%20even%20lighting%2C%20modern%20knowledge%20visual&width=1200&height=675&seq=nav-zhihu-01&orientation=landscape",
    imageSeq: "nav-zhihu-01",
  },
  {
    id: "coursera",
    name: "Coursera",
    url: "https://www.coursera.org",
    host: "coursera.org",
    letter: "C",
    categoryId: "study",
    subCategoryId: "study-course",
    tags: ["公开课", "名校课程", "证书"],
    summary: "全球名校公开课平台，可免费旁听多门专业课程。",
    description:
      "Coursera 汇集来自世界各地高校与企业的在线课程，覆盖计算机、商业、设计、心理等方向。多数课程支持免费旁听，结课可申请证书。课程按周划分并配有作业与讨论区，适合系统性学习某一专业领域。",
    audience: "希望系统学习专业知识、提升职业技能的学习者",
    visits: 331000,
    addedAt: "2026-01-29",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20graduation%20cap%20and%20open%20book%20shapes%20arranged%20in%20a%20clean%20minimal%20composition%20on%20a%20soft%20light%20blue%20background%2C%20bright%20studio%20lighting%2C%20modern%20education%20visual&width=1200&height=675&seq=nav-coursera-01&orientation=landscape",
    imageSeq: "nav-coursera-01",
  },
  {
    id: "duolingo",
    name: "多邻国",
    url: "https://www.duolingo.com",
    host: "duolingo.com",
    letter: "D",
    categoryId: "study",
    subCategoryId: "study-language",
    tags: ["语言学习", "打卡", "趣味"],
    summary: "游戏化语言学习平台，碎片时间练听说读写。",
    description:
      "多邻国通过游戏化关卡设计帮助用户学习外语，覆盖英语、日语、韩语、法语等数十种语言。每日任务、连续打卡排行榜能有效提升坚持度，课程内容偏向日常场景对话，适合零基础入门与碎片时间练习。",
    audience: "想利用碎片时间入门新语言的初学者",
    visits: 289000,
    addedAt: "2026-03-01",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20colorful%20language%20learning%20flash%20cards%20and%20speech%20bubbles%20arranged%20playfully%20on%20a%20fresh%20green%20high%20key%20background%2C%20minimal%20flat%20illustration%20style%2C%20soft%20shadows&width=1200&height=675&seq=nav-duolingo-01&orientation=landscape",
    imageSeq: "nav-duolingo-01",
  },
  {
    id: "fenbi",
    name: "粉笔",
    url: "https://www.fenbi.com",
    host: "fenbi.com",
    letter: "粉",
    categoryId: "study",
    subCategoryId: "study-exam",
    tags: ["题库", "公考", "备考"],
    summary: "在线题库与考试备考平台，覆盖公考、教资与事业单位。",
    description:
      "粉笔提供公务员、事业单位、教师资格、考研等考试方向的在线题库与课程。真题库细分到题型与年份，支持错题本、模考估分与解析视频，适合备考阶段进行系统刷题与查漏补缺。",
    audience: "准备各类编制考试与职业资格考试的学生",
    visits: 224000,
    addedAt: "2026-02-11",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20exam%20answer%20sheet%20and%20pencil%20with%20soft%20pink%20paper%20texture%20on%20a%20clean%20white%20desk%2C%20minimal%20editorial%20composition%2C%20bright%20even%20lighting%2C%20high%20key&width=1200&height=675&seq=nav-fenbi-01&orientation=landscape",
    imageSeq: "nav-fenbi-01",
  },
  {
    id: "feishu",
    name: "飞书",
    url: "https://www.feishu.cn",
    host: "feishu.cn",
    letter: "飞",
    categoryId: "office",
    subCategoryId: "office-doc",
    tags: ["协作", "文档", "效率"],
    summary: "文档、表格、会议一体的团队协作平台。",
    description:
      "飞书整合了云文档、多维表格、即时沟通、视频会议与日历等功能，团队可以在同一个空间内完成讨论与落地。文档支持多人实时编辑与评论，多维表格适合做项目排期与数据管理，适合中小团队日常协作。",
    audience: "需要高效协作的中小团队与远程工作者",
    visits: 412000,
    addedAt: "2026-03-09",
    featured: true,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20collaborative%20document%20cards%20and%20calendar%20blocks%20floating%20on%20a%20clean%20light%20background%2C%20soft%20blue%20and%20teal%20accents%2C%20minimal%20modern%20office%20illustration%2C%20bright%20lighting&width=1200&height=675&seq=nav-feishu-01&orientation=landscape",
    imageSeq: "nav-feishu-01",
  },
  {
    id: "notion",
    name: "Notion",
    url: "https://www.notion.so",
    host: "notion.so",
    letter: "N",
    categoryId: "office",
    subCategoryId: "office-efficiency",
    tags: ["笔记", "知识库", "模板"],
    summary: "模块化笔记与知识库工具，可自由搭建个人工作流。",
    description:
      "Notion 以积木式页面结构著称，用户可以把笔记、任务、数据库、看板组合成适合自己的工作空间。大量社区模板覆盖周计划、读书笔记、内容排期等场景，适合喜欢自定义工作方式的个人与小型团队。",
    audience: "需要搭建个人知识库与项目管理体系的用户",
    visits: 376000,
    addedAt: "2026-02-27",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20white%20note%20blocks%20and%20grid%20layout%20elements%20floating%20in%20a%20minimal%20monochrome%20composition%20with%20soft%20gray%20background%2C%20clean%20editorial%20product%20visual%2C%20bright%20even%20lighting&width=1200&height=675&seq=nav-notion-01&orientation=landscape",
    imageSeq: "nav-notion-01",
  },
  {
    id: "aliyun-drive",
    name: "阿里云盘",
    url: "https://www.alipan.com",
    host: "alipan.com",
    letter: "云",
    categoryId: "office",
    subCategoryId: "office-storage",
    tags: ["云存储", "备份", "分享"],
    summary: "不限速的云存储服务，适合文件备份与大文件分享。",
    description:
      "阿里云盘提供个人文件云端存储与备份服务，上传下载速度体验较好，支持文件夹分享链接与相册备份。适合整理工作资料、备份手机照片、给他人分享较大的设计文件或视频素材。",
    audience: "需要备份资料与分享大文件的个人用户",
    visits: 268000,
    addedAt: "2026-01-20",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20cloud%20storage%20concept%20with%20layered%20folder%20shapes%20and%20soft%20blue%20glow%20on%20a%20pale%20sky%20background%2C%20minimal%20modern%20illustration%2C%20bright%20clean%20lighting&width=1200&height=675&seq=nav-aliyun-01&orientation=landscape",
    imageSeq: "nav-aliyun-01",
  },
  {
    id: "github",
    name: "GitHub",
    url: "https://github.com",
    host: "github.com",
    letter: "G",
    categoryId: "tech",
    subCategoryId: "tech-code",
    tags: ["代码托管", "开源", "开发"],
    summary: "全球最大的代码托管与开源协作平台。",
    description:
      "GitHub 托管了海量开源项目，开发者可以浏览源码、提交 Issue、参与 Pull Request 协作。平台提供 Actions 自动化、Pages 静态部署与完善的包管理生态，是查找技术方案与学习优秀代码实现的首选站点。",
    audience: "程序员、开源贡献者与技术学习者",
    visits: 689000,
    addedAt: "2026-03-14",
    featured: true,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20code%20branch%20and%20commit%20graph%20visual%20with%20soft%20monochrome%20gray%20background%20and%20subtle%20mint%20accents%2C%20minimal%20developer%20illustration%2C%20clean%20high%20key%20lighting&width=1200&height=675&seq=nav-github-01&orientation=landscape",
    imageSeq: "nav-github-01",
  },
  {
    id: "mdn",
    name: "MDN Web Docs",
    url: "https://developer.mozilla.org",
    host: "developer.mozilla.org",
    letter: "M",
    categoryId: "tech",
    subCategoryId: "tech-docs",
    tags: ["前端", "文档", "规范"],
    summary: "权威的 Web 技术文档，前端开发必备参考。",
    description:
      "MDN Web Docs 由 Mozilla 维护，系统收录 HTML、CSS、JavaScript 与 Web API 的规范说明、兼容性表格与示例代码。文档结构清晰，几乎每个属性都有可运行的示例，是解决前端疑难问题的权威来源。",
    audience: "前端开发者、网页设计者与在校学生",
    visits: 356000,
    addedAt: "2026-02-06",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20technical%20documentation%20pages%20and%20code%20snippets%20arranged%20in%20a%20clean%20minimal%20layout%20with%20soft%20white%20and%20gray%20background%2C%20bright%20studio%20lighting%2C%20modern%20editorial%20tech%20visual&width=1200&height=675&seq=nav-mdn-01&orientation=landscape",
    imageSeq: "nav-mdn-01",
  },
  {
    id: "figma",
    name: "Figma",
    url: "https://www.figma.com",
    host: "figma.com",
    letter: "F",
    categoryId: "tech",
    subCategoryId: "tech-design",
    tags: ["设计", "协作", "原型"],
    summary: "在线界面设计工具，支持多人实时协作与原型演示。",
    description:
      "Figma 让设计师在浏览器中完成界面设计、组件管理与原型交互，支持多人实时协作与评论。社区中有大量免费 UI 套件与设计系统可以直接参考，适合产品经理、设计师快速输出可交付的设计稿。",
    audience: "产品设计师、前端工程师与独立创作者",
    visits: 312000,
    addedAt: "2026-03-07",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20interface%20design%20canvas%20with%20colorful%20frames%20and%20shape%20layers%20on%20a%20light%20neutral%20background%2C%20minimal%20modern%20design%20tool%20illustration%2C%20soft%20even%20lighting&width=1200&height=675&seq=nav-figma-01&orientation=landscape",
    imageSeq: "nav-figma-01",
  },
  {
    id: "hellogithub",
    name: "HelloGitHub",
    url: "https://hellogithub.com",
    host: "hellogithub.com",
    letter: "H",
    categoryId: "tech",
    subCategoryId: "tech-code",
    tags: ["开源", "推荐", "项目"],
    summary: "开源项目精选推荐，定期发现有趣好玩的项目。",
    description:
      "HelloGitHub 专注发现与推荐优质开源项目，按月刊形式整理当月热门项目，并附上中文介绍与项目截图。内容覆盖工具、框架、学习资料与趣味应用，适合想了解开源生态又没时间自己翻榜单的开发者和爱好者。",
    audience: "对开源项目感兴趣的技术爱好者与初学者",
    visits: 186000,
    addedAt: "2026-02-15",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20collection%20of%20small%20open%20source%20project%20cards%20with%20star%20icons%20on%20a%20soft%20cream%20background%2C%20minimal%20flat%20illustration%2C%20bright%20high%20key%20studio%20lighting&width=1200&height=675&seq=nav-hellogithub-01&orientation=landscape",
    imageSeq: "nav-hellogithub-01",
  },
  {
    id: "amap",
    name: "高德地图",
    url: "https://www.amap.com",
    host: "amap.com",
    letter: "高",
    categoryId: "life",
    subCategoryId: "life-travel",
    tags: ["地图", "导航", "出行"],
    summary: "地图导航与实时路况查询，出门前先看一眼路线。",
    description:
      "高德地图提供驾车、公交、步行、骑行多种出行方式的路线规划，实时路况与拥堵提示更新及时。网页版还支持周边搜索、地铁图查询与地点收藏，适合出行前规划路线与查找附近服务设施。",
    audience: "自驾出行、通勤与外出办事的普通用户",
    visits: 723000,
    addedAt: "2026-03-11",
    featured: true,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20city%20map%20with%20route%20lines%20and%20location%20pins%20on%20a%20soft%20mint%20and%20light%20beige%20background%2C%20minimal%20modern%20navigation%20illustration%2C%20clean%20bright%20lighting&width=1200&height=675&seq=nav-amap-01&orientation=landscape",
    imageSeq: "nav-amap-01",
  },
  {
    id: "12306",
    name: "铁路12306",
    url: "https://dadasoda.com",
    host: "12306.cn",
    letter: "铁",
    categoryId: "life",
    subCategoryId: "life-travel",
    tags: ["火车票", "出行", "官方"],
    summary: "官方铁路购票平台，车次查询与余票一目了然。",
    description:
      "铁路 12306 是中国铁路官方购票渠道，提供车次查询、余票查看、购票改签与退票服务。页面支持按出发到达站与时间段筛选，并提供学生票、预约购票与候补购票功能，购票安全有保障。",
    audience: "需要购买火车票、查询车次信息的出行人群",
    visits: 664000,
    addedAt: "2026-01-16",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20high%20speed%20train%20silhouette%20on%20a%20clean%20pale%20blue%20background%20with%20minimal%20motion%20lines%2C%20modern%20flat%20illustration%2C%20bright%20even%20studio%20lighting&width=1200&height=675&seq=nav-12306-01&orientation=landscape",
    imageSeq: "nav-12306-01",
  },
  {
    id: "meituan",
    name: "美团",
    url: "https://www.meituan.com",
    host: "meituan.com",
    letter: "美",
    categoryId: "shopping",
    subCategoryId: "shopping-local",
    tags: ["外卖", "本地生活", "到店"],
    summary: "外卖、到店餐饮与本地生活服务的一站式入口。",
    description:
      "美团覆盖外卖、到店餐饮、酒店旅行、电影演出等本地生活服务。用户可以按位置查看附近商户、评价与优惠，外卖下单流程简便，适合工作日快速解决用餐，也适合周末安排朋友聚餐与出游。",
    audience: "城市上班族、学生与需要本地生活服务的家庭",
    visits: 741000,
    addedAt: "2026-03-15",
    featured: true,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20takeout%20boxes%20and%20restaurant%20table%20items%20on%20a%20warm%20yellow%20orange%20high%20key%20background%2C%20minimal%20clean%20food%20delivery%20illustration%2C%20soft%20studio%20lighting&width=1200&height=675&seq=nav-meituan-01&orientation=landscape",
    imageSeq: "nav-meituan-01",
  },
  {
    id: "pinduoduo",
    name: "拼多多",
    url: "https://www.pinduoduo.com",
    host: "pinduoduo.com",
    letter: "拼",
    categoryId: "shopping",
    subCategoryId: "shopping-deal",
    tags: ["折扣", "拼团", "农产品"],
    summary: "拼团与特卖模式电商，日用百货价格有优势。",
    description:
      "拼多多以拼团和百亿补贴模式吸引用户，日用百货、生鲜农产品、小家电等品类价格优势明显。平台按类目和场景组织商品，支持多人拼团与产地直发，适合日常囤货与追求性价比的消费者。",
    audience: "注重性价比、家庭囤货与生鲜采购的用户",
    visits: 587000,
    addedAt: "2026-02-03",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20fresh%20groceries%20and%20small%20packages%20in%20a%20clean%20minimal%20flat%20lay%20composition%20on%20a%20soft%20red%20and%20cream%20background%2C%20bright%20high%20key%20lighting%2C%20modern%20ecommerce%20visual&width=1200&height=675&seq=nav-pdd-01&orientation=landscape",
    imageSeq: "nav-pdd-01",
  },
  {
    id: "dianping",
    name: "大众点评",
    url: "https://www.dianping.com",
    host: "dianping.com",
    letter: "点",
    categoryId: "life",
    subCategoryId: "life-service",
    tags: ["评价", "探店", "美食"],
    summary: "本地商户评价与探店攻略，找餐厅先看真实点评。",
    description:
      "大众点评汇集餐厅、咖啡、美容、亲子等本地商户信息与用户评价，提供人均消费、环境照片与排队情况。按商圈、口味、价格筛选可以帮助快速决策，适合在外就餐前了解口碑与特色菜品。",
    audience: "喜欢探店、需要聚餐决策参考的城市用户",
    visits: 498000,
    addedAt: "2026-02-20",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20restaurant%20table%20with%20plates%20and%20review%20stars%20on%20a%20warm%20cream%20background%2C%20minimal%20editorial%20food%20photography%20style%2C%20soft%20bright%20lighting%2C%20clean%20composition&width=1200&height=675&seq=nav-dianping-01&orientation=landscape",
    imageSeq: "nav-dianping-01",
  },
  {
    id: "ximalaya",
    name: "喜马拉雅",
    url: "https://www.ximalaya.com",
    host: "ximalaya.com",
    letter: "喜",
    categoryId: "entertainment",
    subCategoryId: "entertainment-music",
    tags: ["播客", "有声书", "电台"],
    summary: "音频内容平台，有声书、播客与知识课程丰富。",
    description:
      "喜马拉雅提供有声书、播客节目、相声电台、儿童故事与付费课程等音频内容。用户可以按主题与场景筛选，通勤、睡前、开车时随时收听，很多节目更新频率高，适合把碎片时间变成输入时间。",
    audience: "通勤族、学生与喜欢收听音频内容的用户",
    visits: 352000,
    addedAt: "2026-02-09",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20podcast%20studio%20microphone%20with%20soft%20orange%20sound%20waves%20on%20a%20clean%20warm%20background%2C%20minimal%20modern%20audio%20visual%2C%20bright%20high%20key%20lighting&width=1200&height=675&seq=nav-ximalaya-01&orientation=landscape",
    imageSeq: "nav-ximalaya-01",
  },
  {
    id: "ctrip",
    name: "携程旅行",
    url: "https://www.ctrip.com",
    host: "ctrip.com",
    letter: "携",
    categoryId: "travel",
    subCategoryId: "travel-ticket",
    tags: ["机票", "酒店", "旅游"],
    summary: "机票酒店与自由行预订平台，行程规划更方便。",
    description:
      "携程提供机票、酒店、火车票、门票、租车与自由行套餐的一站式预订服务。用户可以借助行程助手与价格提醒比较不同日期方案，平台还提供用户游记与景点攻略，适合出行前做整体规划。",
    audience: "计划出游、需要预订机票与酒店的用户",
    visits: 476000,
    addedAt: "2026-03-04",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20travel%20essentials%20suitcase%20passport%20and%20ticket%20on%20a%20soft%20light%20blue%20background%2C%20minimal%20clean%20editorial%20travel%20visual%2C%20bright%20high%20key%20lighting%2C%20gentle%20shadows&width=1200&height=675&seq=nav-ctrip-01&orientation=landscape",
    imageSeq: "nav-ctrip-01",
  },
  {
    id: "mafengwo",
    name: "马蜂窝",
    url: "https://www.mafengwo.cn",
    host: "mafengwo.cn",
    letter: "马",
    categoryId: "travel",
    subCategoryId: "travel-guide",
    tags: ["攻略", "游记", "自由行"],
    summary: "自由行攻略与游记社区，目的地信息整理细致。",
    description:
      "马蜂窝以旅行攻略和用户游记为核心，目的地页面整合了景点、交通、住宿、美食与购物建议，并提供行前准备清单。用户还可以按天数和预算参考他人的行程路线，适合自由行爱好者做深度规划。",
    audience: "喜欢自由行、需要目的地详细攻略的旅行者",
    visits: 245000,
    addedAt: "2026-01-24",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20travel%20map%20and%20camera%20with%20warm%20sand%20and%20yellow%20tones%20on%20a%20clean%20minimal%20background%2C%20editorial%20travel%20illustration%2C%20bright%20soft%20lighting&width=1200&height=675&seq=nav-mafengwo-01&orientation=landscape",
    imageSeq: "nav-mafengwo-01",
  },
  {
    id: "alipay",
    name: "支付宝",
    url: "https://www.alipay.com",
    host: "alipay.com",
    letter: "支",
    categoryId: "finance",
    subCategoryId: "finance-bank",
    tags: ["支付", "生活缴费", "理财"],
    summary: "支付与生活缴费入口，账单管理与理财功能齐全。",
    description:
      "支付宝提供线上支付、生活缴费、账单查询与政务服务入口，网页版可完成部分管理操作。平台还整合余额宝、基金等理财与信用服务，适合日常账单管理与线上缴费，注意保管好账户安全信息。",
    audience: "需要线上支付与生活缴费的普通用户",
    visits: 812000,
    addedAt: "2026-02-28",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20payment%20card%20and%20mobile%20transfer%20shapes%20in%20clean%20blue%20tone%20on%20a%20pale%20high%20key%20background%2C%20minimal%20fintech%20illustration%2C%20soft%20even%20lighting&width=1200&height=675&seq=nav-alipay-01&orientation=landscape",
    imageSeq: "nav-alipay-01",
  },
  {
    id: "eastmoney",
    name: "东方财富网",
    url: "https://www.eastmoney.com",
    host: "eastmoney.com",
    letter: "东",
    categoryId: "finance",
    subCategoryId: "finance-invest",
    tags: ["行情", "基金", "财经"],
    summary: "财经行情与基金信息平台，数据更新及时。",
    description:
      "东方财富网提供股票、基金、期货、债券等行情数据与财经新闻，支持自选股管理与基金筛选对比。数据页面信息密集，配合行情图表与公告、研报入口，适合投资者做日常盯盘与基础研究。",
    audience: "关注行情、需要查询基金与市场数据的投资者",
    visits: 318000,
    addedAt: "2026-02-14",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20stock%20market%20chart%20with%20ascending%20line%20and%20candlestick%20shapes%20on%20a%20clean%20white%20background%20with%20warm%20orange%20accent%2C%20minimal%20finance%20visual%2C%20bright%20lighting&width=1200&height=675&seq=nav-eastmoney-01&orientation=landscape",
    imageSeq: "nav-eastmoney-01",
  },
  {
    id: "douban",
    name: "豆瓣",
    url: "https://www.douban.com",
    host: "douban.com",
    letter: "豆",
    categoryId: "social",
    subCategoryId: "social-forum",
    tags: ["书影音", "评分", "社区"],
    summary: "书影音评分与兴趣小组社区，看评价再决定。",
    description:
      "豆瓣以图书、电影、音乐的评分与评论为核心，用户可以在看片前参考评分与长评，也能加入兴趣小组参与讨论。平台还提供读书笔记、观影记录等功能，适合喜欢文艺内容与深度评论的用户。",
    audience: "喜欢阅读、观影与在兴趣小组交流的用户",
    visits: 287000,
    addedAt: "2026-01-31",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20stack%20of%20books%20and%20film%20reel%20in%20a%20quiet%20muted%20green%20high%20key%20composition%2C%20minimal%20editorial%20illustration%2C%20soft%20natural%20lighting%2C%20calm%20atmosphere&width=1200&height=675&seq=nav-douban-01&orientation=landscape",
    imageSeq: "nav-douban-01",
  },
  {
    id: "xiaohongshu",
    name: "小红书",
    url: "https://www.xiaohongshu.com",
    host: "xiaohongshu.com",
    letter: "小",
    categoryId: "social",
    subCategoryId: "social-platform",
    tags: ["种草", "攻略", "生活"],
    summary: "生活方式分享社区，攻略与种草内容更新快。",
    description:
      "小红书以图文与短视频笔记为主，覆盖美妆、穿搭、家居、旅行、美食等生活话题。搜索功能按场景与关键词返回真实体验分享，适合做消费前的信息比对，也能发现不少实用攻略与好物清单。",
    audience: "关注生活方式、需要真实体验参考的年轻用户",
    visits: 512000,
    addedAt: "2026-03-13",
    featured: true,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20lifestyle%20photo%20cards%20with%20soft%20pink%20and%20cream%20palette%20floating%20in%20a%20clean%20minimal%20grid%20layout%2C%20bright%20high%20key%20editorial%20visual%2C%20gentle%20rounded%20shapes&width=1200&height=675&seq=nav-xhs-01&orientation=landscape",
    imageSeq: "nav-xhs-01",
  },
  {
    id: "guokr",
    name: "果壳",
    url: "https://www.guokr.com",
    host: "guokr.com",
    letter: "果",
    categoryId: "news",
    subCategoryId: "news-tech",
    tags: ["科普", "科学", "知识"],
    summary: "科普内容与科学资讯社区，解释生活中的科学现象。",
    description:
      "果壳聚焦科学传播，内容涵盖生命科学、健康、环境、心理与前沿科技。文章往往从日常疑问出发，给出可理解的解释与引用来源，适合想认真了解科学话题、避免被谣言带偏的普通读者。",
    audience: "对科学科普感兴趣、希望获取可靠信息的读者",
    visits: 132000,
    addedAt: "2026-02-07",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20science%20lab%20glassware%20and%20atom%20shapes%20in%20a%20clean%20mint%20and%20white%20composition%2C%20minimal%20modern%20illustration%2C%20bright%20high%20key%20lighting&width=1200&height=675&seq=nav-guokr-01&orientation=landscape",
    imageSeq: "nav-guokr-01",
  },
  {
    id: "36kr",
    name: "36氪",
    url: "https://www.36kr.com",
    host: "36kr.com",
    letter: "3",
    categoryId: "news",
    subCategoryId: "news-tech",
    tags: ["创投", "科技", "商业"],
    summary: "科技与创投资讯平台，了解行业动态与新兴公司。",
    description:
      "36氪报道科技、创业与投资领域的动态，涵盖公司新闻、融资事件、行业观察与深度分析。内容更新快，适合关注互联网商业变化的从业者与企业主，用来快速掌握行业最新动向。",
    audience: "科技行业从业者、创业者与投资相关人士",
    visits: 198000,
    addedAt: "2026-02-12",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20startup%20growth%20chart%20and%20modular%20building%20blocks%20on%20a%20clean%20pale%20gray%20background%20with%20orange%20accents%2C%20minimal%20business%20illustration%2C%20bright%20lighting&width=1200&height=675&seq=nav-36kr-01&orientation=landscape",
    imageSeq: "nav-36kr-01",
  },
  {
    id: "keep",
    name: "Keep",
    url: "https://www.gotokeep.com",
    host: "gotokeep.com",
    letter: "K",
    categoryId: "life",
    subCategoryId: "life-health",
    tags: ["运动", "健身", "健康"],
    summary: "居家健身课程与运动记录工具，跟练计划清晰。",
    description:
      "Keep 提供居家健身课程、跑步骑行记录与训练计划，课程按部位与难度分类，配有动作示范与计时提醒。适合没有健身房条件的用户在家跟练，也可以通过数据记录查看训练进步情况。",
    audience: "希望在家健身、保持运动习惯的上班族",
    visits: 217000,
    addedAt: "2026-03-06",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20fitness%20mat%20dumbbell%20and%20water%20bottle%20in%20a%20clean%20minimal%20composition%20on%20a%20pale%20cool%20background%2C%20bright%20high%20key%20studio%20lighting%2C%20modern%20lifestyle%20visual&width=1200&height=675&seq=nav-keep-01&orientation=landscape",
    imageSeq: "nav-keep-01",
  },
  {
    id: "12345",
    name: "国家政务服务平台",
    url: "https://gjzwfw.www.gov.cn",
    host: "gjzwfw.www.gov.cn",
    letter: "政",
    categoryId: "life",
    subCategoryId: "life-service",
    tags: ["政务", "办事", "查询"],
    summary: "政务服务总入口，证件办理与信息查询更集中。",
    description:
      "国家政务服务平台汇集各地各部门的政务服务事项，提供办事指南、进度查询与常用便民服务入口。用户可以按主题与部门查找所需事项，避免在多个网站之间反复跳转，办事前先在这里确认所需材料。",
    audience: "需要办理政务事项、查询公共服务的居民",
    visits: 176000,
    addedAt: "2026-01-12",
    featured: false,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20government%20service%20building%20facade%20in%20minimal%20flat%20illustration%20with%20soft%20blue%20gray%20tones%20and%20clean%20white%20background%2C%20official%20bright%20high%20key%20style&width=1200&height=675&seq=nav-gov-01&orientation=landscape",
    imageSeq: "nav-gov-01",
  },
];

export const getSiteById = (id: string) => navSites.find((site) => site.id === id);